import {
  MERCHANT_DASHBOARD_API_URL,
  SERVER_MENU_SYNC_URL,
  SERVER_URL
} from './API_CONSTANTS';

// Location settings API endpoints
export const GET_LOCATION_SETTINGS_DATA = () =>
  `${SERVER_URL}/locations-management`;

export const GET_LOCATION_SETTINGS_DATA_BY_ID = (id) =>
  `${SERVER_URL}/locations-management/${id}`;

export const UPDATE_LOCATION_SETTINGS_DATA = (id) =>
  `${SERVER_URL}/locations-management/${id}`;

export const PAUSE_LOCATION = (id) =>
  `${SERVER_URL}/locations-management/${id}/pause`;

export const UNPAUSE_LOCATION = (id) =>
  `${SERVER_URL}/locations-management/${id}/unpause`;

export const POST_LOCATION_SETTINGS_DATA = () =>
  `${SERVER_URL}/locations-management`;

export const GET_CALLING_PHONE = (countryCode) =>
  `${SERVER_URL}/geographi/${countryCode}/callingCode`;

export const PUBLISH_LOCATION = (menuConfigId) =>
  `${SERVER_MENU_SYNC_URL}/sync-bot/${menuConfigId}`;

export const UPDATE_LOCATION_ACCOUNT_TEMPLATE = (id) =>
  `${SERVER_URL}/locations-management/${id}`;

export const UPDATE_FEEDBACK_SETTINGS = (id) =>
  `${SERVER_URL}/locations-management/settings/${id}/feedback`;

export const UPDATE_FEEDBACK_BANNER_STATUS = (id) =>
  `${SERVER_URL}/locations-management/settings/${id}/feedback/banner`;

export const GET_SPECIAL_HOURS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/special-hours`;

export const CREATE_SPECIAL_HOURS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/special-hours`;

export const DELETE_SPECIAL_HOURS = (locationId, specialHoursId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/special-hours/${specialHoursId}`;

export const CREATE_STORE_HOLIDAYS = (id) =>
  `${SERVER_URL}/locations-management/settings/${id}/holidays-request`;

export const GET_SELF_DELIVERY_REPORT_EMAIL = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/self-delivery-report-email`;

export const UPDATE_SELF_DELIVERY_REPORT_EMAIL = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/self-delivery-report-email`;

export const GET_SUCCESS_MANAGER = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/success-manager`;
